import { Navigate } from 'react-router-dom';
import Page404 from '@/common/views/Page404';
import AgentsPage from './views/Agents';
import DataTracePage from './views/DataTrace';
import MembersPage from './views/Members';
import TracePage from './views/Trace';

export const settingsRoutes = [
  {
    path: 'settings',
    name: '系统设置',
    icon: 'setting',
    ownerAdminOnly: true,
    children: [
      {
        index: true,
        element: <Navigate to="members" replace />,
      },
      {
        path: 'members',
        name: '成员管理',
        icon: 'team',
        element: <MembersPage />,
      },
      {
        path: 'trace',
        name: '监测账号',
        icon: 'profile',
        element: <TracePage />,
      },
      {
        path: 'data-trace',
        name: '监测日志',
        icon: 'lineChart',
        element: <DataTracePage />,
      },
      {
        path: 'agents',
        name: '智能体管理',
        icon: 'robot',
        element: <AgentsPage />,
      },
      {
        path: '*',
        element: <Page404 />,
      },
    ],
  },
];
